import * as React from 'react';
import { css } from '@emotion/core';
import Card from '../../../layout/card/Card';
import CardHeader from '../../../layout/card/CardHeader';
import { useMsgText } from '../../../localization/hooks';
import { Str } from '../../../localization/translationKeys';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import Msg from '../../../localization/Msg';
import { COLORS } from '../../../globalStyle/colors';
import Toggle from '../../../forms/Toggle';


const styles = {
  root:           css`
    padding: 0;
    overflow: hidden;
  `,
  header:         css`
    padding-top: 14px;
    margin-left: 14px;
    margin-right: 14px;
    margin-bottom: 28px;
  `,
  reminderTxt:    css`
    display: block;
    margin-left: 28px;
    margin-right: 28px;
    margin-bottom: 14px;
    color: ${COLORS.DARK_GREY};
  `,
  reminderToggle: css`
    margin-left: 28px;
    margin-right: 28px;
    margin-bottom: 28px;
  `,
};


type Props = {
  remindersEnabled: boolean;
  onChangeRemindersEnabled: (newValue: boolean) => void;
  className?: string;
};


/**
 * DevPlanRemindersCard: a component that
 *
 * PureComponent: true
 * Redux Connected: false
 */
const DevPlanRemindersCard: React.FC<Props> = props => {
  const title = useMsgText(Str.EmailReminders);

  return (
    <Card css={styles.root} className={props.className}>
      <CardHeader title={title} icon={faBell} css={styles.header} />

      <Msg str={Str.DevPlanReminders} css={styles.reminderTxt} />

      <Toggle value={props.remindersEnabled} onChange={props.onChangeRemindersEnabled} css={styles.reminderToggle} />
    </Card>
  );
};

export default DevPlanRemindersCard;
